import React from 'react';
import { useTranslation } from 'react-i18next';

import useSiteContext from 'hooks/useSiteContext';

import SubPage from './SubPage';

const SubPageContainer = (props) => {
  const { t } = useTranslation();
  const { isInTeams } = useSiteContext();
  return <SubPage isInTeams={isInTeams} t={t} {...props} />;
};

export default SubPageContainer;
